<template>
  <CForm ref="form" class="needs-validation"   >
    <CInput
        label="Firma Adı: "
        horizontal
        type="text"
        v-model="data.iAddressCompanyName"
    />

    <CInput
        label="Vergi Dairesi: "
        horizontal
        type="text"
        v-model="data.iAddressCompanyTaxOffice"
    />

    <CInput
        label="Vergi No: "
        horizontal
        type="text"
        v-model="data.iAddressCompanyTaxNumber"
    />

    <div class="row">
      <div class="col-3">
        E-Faturaya Tabi:
      </div>
      <div class="col-9">
        <CSwitch
            class="mr-1"
            size="lg"
            color="primary"
            :checked.sync="data.companyEinvoiceMember"
        />
      </div>
    </div>
  </CForm>
</template>

<script>
export default{
  name: "EInvoiceForm",
  props:{
    validated: Boolean,
    params: Object,
    actionType: String,
  },
  watch:{
    params: function(val){
      this.data = {...val};
    },
    actionType:  function(val){
      if(val == 'create'){
        this.data = {...this.params};
      }
    },
  },
  data: function(){
    return{
      data: this.params ? {...this.params} : {},

    }
  }
}
</script>